import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';

import MainContent from './MainContent';

const styles = {
  caption: {
    fontSize: '0.9rem',
  },
  root: {
    marginTop: '32px',
  },
};

const ViewHeader = (props) => {
  const {
    classes, title, caption, children,
  } = props;
  return (
    <MainContent>
      <Typography variant="h6" gutterBottom>{title}</Typography>
      <Typography className={classes.caption} variant="caption" gutterBottom>{caption}</Typography>
      <Divider />
      <div className={classes.root}>
        {children}
      </div>
    </MainContent>
  );
};

ViewHeader.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  title: PropTypes.string.isRequired,
  caption: PropTypes.string.isRequired,
  children: PropTypes.instanceOf(Object).isRequired,
};

export default withStyles(styles)(ViewHeader);
